import { createFileRoute } from '@tanstack/react-router'

import { PortalMeetingPollPage } from '@/components/portal/portal-meeting-poll'

export const Route = createFileRoute('/portal/rendez-vous/$pollId')({
  component: PortalMeetingPollRoute,
})

function PortalMeetingPollRoute() {
  const { pollId } = Route.useParams()
  return <PortalMeetingPollPage key={pollId} id={pollId} />
}
